import { render, staticRenderFns } from "./TradeOrdersModal.vue?vue&type=template&id=4cdb26bb&scoped=true"
import script from "./TradeOrdersModal.vue?vue&type=script&lang=js"
export * from "./TradeOrdersModal.vue?vue&type=script&lang=js"
import style0 from "./TradeOrdersModal.vue?vue&type=style&index=0&id=4cdb26bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdb26bb",
  null
  
)

export default component.exports